import * as fromDatatype from '../datatype-library/index'

export interface bl_mrp_process_instance_ext_RowInterface {
  guid: fromDatatype.VarcharDatatypeInterface;
  hdr_guid: fromDatatype.VarcharDatatypeInterface;
  line_guid: fromDatatype.VarcharDatatypeInterface;
  ext_type: fromDatatype.VarcharDatatypeInterface;
  ext_code: fromDatatype.VarcharDatatypeInterface;
  ext_option: fromDatatype.VarcharDatatypeInterface;
  property_json: any;
  param_code: fromDatatype.VarcharDatatypeInterface;
  param_name: fromDatatype.VarcharDatatypeInterface;
  param_type: fromDatatype.VarcharDatatypeInterface;
  param_option_json: any;
  value_string: fromDatatype.VarcharDatatypeInterface;
  value_file: fromDatatype.VarcharDatatypeInterface;
  value_numeric: fromDatatype.NumericDatatypeInterface;
  value_datetime: fromDatatype.VarcharDatatypeInterface;
  value_json: any;
  created_date: fromDatatype.VarcharDatatypeInterface;
  updated_date: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.VarcharDatatypeInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  acl_config: any;
  acl_policy: any;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
}

export class bl_mrp_process_instance_ext_RowClass 
  implements bl_mrp_process_instance_ext_RowInterface {
  guid: fromDatatype.VarcharDatatypeInterface;
  hdr_guid: fromDatatype.VarcharDatatypeInterface;
  line_guid: fromDatatype.VarcharDatatypeInterface;
  ext_type: fromDatatype.VarcharDatatypeInterface;
  ext_code: fromDatatype.VarcharDatatypeInterface;
  ext_option: fromDatatype.VarcharDatatypeInterface;
  property_json: any;
  param_code: fromDatatype.VarcharDatatypeInterface;
  param_name: fromDatatype.VarcharDatatypeInterface;
  param_type: fromDatatype.VarcharDatatypeInterface;
  param_option_json: any;
  value_string: fromDatatype.VarcharDatatypeInterface;
  value_file: fromDatatype.VarcharDatatypeInterface;
  value_numeric: fromDatatype.NumericDatatypeInterface;
  value_datetime: fromDatatype.VarcharDatatypeInterface;
  value_json: any;
  created_date: fromDatatype.VarcharDatatypeInterface;
  updated_date: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.VarcharDatatypeInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  acl_config: any;
  acl_policy: any;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
}